import owd from 'owd/owd';

export default class SkipLink extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('click', (e) => {
            e.preventDefault();
            
            const href = this.$element.attr('href');
            
            $('html, body').animate({
				scrollTop: $(href).offset().top + 'px'
			}, 1000, 'easeOutQuint', () => {
                location.hash = href;
            });
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('skip-link', {
	component: SkipLink
});
